module.exports = __webpack_public_path__ + "img/fpx.a528be4f.png";